/* Botaverra - pastille scintillante au-dessus du titre de page, et centrage du
   bloc de titre.

   NOM DU FICHIER HISTORIQUE. Il ne traitait que les pages de politiques a sa
   creation (2026-08-22) ; il traite depuis le 2026-09-02 le blog et les pages
   de collection. Le nom et la classe `bvpol__` sont conserves POUR NE PAS
   DUPLIQUER L'HABILLAGE : la geometrie de la pastille vit dans
   botaverra-politiques-titre.css et sa couleur dans botaverra-icones.css, avec
   les autres surtitres du site. Creer une seconde classe aurait fait diverger
   les pastilles au premier changement de palette.

   REGLE DE SITE, rappelee deux fois par l'utilisateur le 2026-09-02 : TOUT
   TITRE DE PAGE porte une pastille au-dessus, et le bloc est centre. Une
   nouvelle rubrique s'ajoute donc ICI, elle ne se traite pas a part.

   POURQUOI EN JAVASCRIPT. Le titre est un <h1> pose par le gabarit, en dehors
   du contenu modifiable depuis l'admin. Et plusieurs pages partagent le meme
   gabarit : une regle CSS seule ne saurait pas distinguer une politique de la
   page Contact.

   =========================================================================
   POUR CHANGER OU AJOUTER UN LIBELLE : tout est dans LIBELLES ci-dessous.
   =========================================================================

   LA PASTILLE NE REPETE JAMAIS LE TITRE : elle annonce la rubrique, ou ramene
   au niveau superieur quand il y en a un (article -> liste du blog).

   LE CENTRAGE PASSE PAR UNE CLASSE, PAS PAR UNE REGLE GLOBALE. Le script pose
   `bvpol__entete` sur le conteneur du titre ; la feuille centre uniquement ce
   qui porte cette classe. */
(function () {
  /* ---- Libelles, a modifier ici ------------------------------------- */
  var LIBELLES = {
    politiques: { index: 'Informations légales', page: 'Nos politiques' },
    blogs: {
      /* cle = descripteur du blog dans l'URL */
      conseils: { liste: 'Le blog', article: 'Conseils de culture' },
      defaut: { liste: 'Le blog', article: 'Le blog' }
    },
    collections: {
      /* cle = descripteur de la collection dans l'URL */
      'nos-tours': 'La boutique',
      'nos-graines': 'La boutique',
      defaut: 'La boutique'
    }
  };
  /* -------------------------------------------------------------------- */

  function normaliser(u) {
    return String(u || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
  }

  var chemin = normaliser(location.pathname);
  var etiquette = null;
  var href = null;

  var liste = window.BV_POLITIQUES || [];
  var estIndex = /\/pages\/nos-politiques$/.test(chemin);
  var estPolitique = estIndex || liste.some(function (x) {
    return normaliser(x.u) === chemin;
  });

  var blog = chemin.match(/^\/blogs\/([^\/]+)(?:\/([^\/]+))?$/);
  var collection = chemin.match(/^\/collections\/([^\/]+)$/);

  if (estPolitique) {
    /* Sur l'index, la pastille ne renvoie nulle part : un lien vers la page ou
       l'on se trouve deja n'apporte rien et deroute. */
    etiquette = estIndex ? LIBELLES.politiques.index : LIBELLES.politiques.page;
    href = estIndex ? null : '/pages/nos-politiques';
  } else if (blog) {
    var reglage = LIBELLES.blogs[blog[1]] || LIBELLES.blogs.defaut;
    if (blog[2]) {
      etiquette = reglage.article;
      href = '/blogs/' + blog[1];
    } else {
      etiquette = reglage.liste;
      href = null;
    }
  } else if (collection) {
    /* "all" est la collection technique de Shopify : elle sert au flux Merchant
       Center et n'est pas une page de vitrine, on la laisse tranquille. */
    if (collection[1] === 'all') return;
    etiquette = LIBELLES.collections[collection[1]] || LIBELLES.collections.defaut;
    href = null;
  } else {
    return;
  }

  var h1 = document.querySelector('#MainContent h1') || document.querySelector('main h1');
  if (!h1 || h1.dataset.bvpolPastille === 'oui') return;
  h1.dataset.bvpolPastille = 'oui';

  var el = document.createElement(href ? 'a' : 'span');
  el.className = 'bvpol__pastille';
  el.textContent = etiquette;
  if (href) el.href = href;

  var bloc = h1.parentNode;
  if (bloc && bloc.classList) bloc.classList.add('bvpol__entete');

  bloc.insertBefore(el, h1);
})();
